module.exports = __webpack_public_path__ + "assets/img/logo.e38c68dd.png";